import React, { useMemo } from 'react';
import { GlobalHotKeys, GlobalHotKeysProps } from 'react-hotkeys';

/**
 * Sets hot keys.
 *
 * @param {GlobalHotKeysProps} props Hot keys props.
 *
 */

export const BaseHotKeys = ({ handlers, ...props }) => {
  const innerHandlers = useMemo(() => {
    const h = {};
    Object.keys(handlers ?? {}).forEach((k) => {
      h[k] = (e) => {
        const isAnyModalOpen = window?.document?.getElementsByClassName?.('k-dialog')?.length > 0
          || window?.document?.getElementsByClassName?.('k-window')?.length > 0;
        if (!isAnyModalOpen) {
          handlers?.[k]?.(e);
        }
      };
    });
    return h;
  }, [handlers]);

  return <GlobalHotKeys {...props} handlers={innerHandlers} />;
};